import { useNavigate } from "react-router-dom";
import { IMenuViewModel } from "../../model/response/auth/IMenuViewModel";
import { ActionList, ActionMenu, Box } from "@primer/react";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useAuth } from "../../hooks/useAuth";
import { useMemo } from "react";
import clsx from "clsx";
import styles from "./AppButton.module.css";
import { eNavSubMode } from "../../model/common/eNavSubMode";
import { rootActions } from "../../state/actions/rootActions";
import TextWithEllipse from "../text-with-ellipse";

interface IAppButtonProps {
    module: IMenuViewModel
}
interface ISubMenuProps {
    menuParent: IMenuViewModel,
    key?: string
}
const SubMenu = (props: ISubMenuProps) => {
    const { menuParent } = props;

    const navigate = useNavigate();
    return (
        <>
            {menuParent.items.length > 0 &&
                <>
                    {menuParent.items.map(menu => {

                        return (
                            <ActionList.Item onClick={() => {
                                navigate({
                                    pathname: `../../${menu.path}`
                                })
                            }}>
                                <ActionList.LeadingVisual>
                                    {menu.icon &&
                                        <i className={`${menu.icon}`}></i>
                                    }
                                </ActionList.LeadingVisual>
                                {menu.name}

                            </ActionList.Item>

                        )
                    })}

                </>
            }
        </>
    )
}
const AppButton = (props: IAppButtonProps) => {
    const dispatch = useAppDispatch();
    const { module } = props;
    const { name, icon } = module;
    const { navSubMode, moduleSelected } = useAppSelector(x => x.common.layout)
    const { user } = useAuth();
    const menus = useMemo(() => {
        const menuAll = user?.menus ?? [];
        if (moduleSelected) {
            return menuAll.filter(x => x.id === moduleSelected.id)
        }
        return menuAll;
    }, [moduleSelected, user]);

    const is_focused = module.id === moduleSelected?.id;
    const is_disabled = false;
    return (
        <>
            {navSubMode === eNavSubMode.FULL &&
                <div className={clsx(styles.container,
                    is_focused ? styles.active : "",
                    is_disabled ? styles.disabled : ""
                )}
                    onClick={() => {
                        dispatch(rootActions.common.layout.CHANGE_MODULE_SELECTED(module))
                    }}
                >
                    <div className={styles.icon}>
                        <div className={styles.iconState}>
                            {is_focused &&
                                <div className={styles.activeState}>
                                    &nbsp;
                                </div>}
                        </div>
                        <div className={styles.iconImage}>
                            <div className={clsx(styles.iconApp, is_focused ? styles.active : "")}>
                                {icon &&
                                    <img alt='' src={`../../images/${icon}`}
                                        style={{
                                            width: "32px"
                                        }}
                                    />
                                }

                            </div>
                        </div>
                        <div className={styles.iconState}>

                        </div>
                    </div>
                    <div className={styles.appName}>
                        <TextWithEllipse text={name} lineNumber={1} />
                    </div>
                </div>
            }
            {navSubMode === eNavSubMode.POPUP &&
                <ActionMenu onOpenChange={() => {
                    dispatch(rootActions.common.layout.CHANGE_MODULE_SELECTED(module))

                }}>
                    <ActionMenu.Anchor>
                        <div className={clsx(styles.container,
                            is_focused ? styles.active : "",
                            is_disabled ? styles.disabled : ""
                        )}
                            onClick={() => {
                                // console.log({ xxx: "1231313" });
                                dispatch(rootActions.common.layout.CHANGE_MODULE_SELECTED(module))
                            }}
                        >
                            <div className={styles.icon}>
                                <div className={styles.iconState}>
                                    {is_focused &&
                                        <div className={styles.activeState}>
                                            &nbsp;
                                        </div>}
                                </div>
                                <div className={styles.iconImage}>
                                    <div className={clsx(styles.iconApp, is_focused ? styles.active : "")}>
                                        {icon &&
                                            <img alt='' src={`../../images/${icon}`}
                                                style={{
                                                    width: "24px"
                                                }}
                                            />
                                        }

                                    </div>
                                </div>
                                <div className={styles.iconState}>

                                </div>
                            </div>
                            <div className={styles.appName}>
                                <TextWithEllipse text={name} lineNumber={1} />
                            </div>
                        </div>
                    </ActionMenu.Anchor>
                    <ActionMenu.Overlay side='outside-right'>
                        <div className={styles.popup} style={{
                            maxHeight: window.innerHeight - 300,
                            overflowY: "scroll"
                        }}>
                            <ActionList>
                                {menus.map(menu => {
                                    return (
                                        <ActionList.Group key={menu.id.toString()}> 
                                            <ActionList.GroupHeading>
                                                {menu.name}
                                            </ActionList.GroupHeading>
                                            <SubMenu menuParent={menu} key={menu.id.toString()} />
                                        </ActionList.Group>
                                    );
                                })}

                            </ActionList>
                        </div>
                    </ActionMenu.Overlay>
                </ActionMenu>
            }
        </>
    );
};

export default AppButton;